export default __webpack_public_path__ + "static/media/rebirthisland.4e9fbceb.jpg";